import { Box, Typography } from '@mui/material';
import React, { Component } from 'react';
class DrawerMobile extends Component {
    state = {  } 
    render() { 
        return (
            <>
                {this.props.children}
            </>
        );
    }
}
 
export default DrawerMobile;